"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSkeleton = void 0;
var TableSkeleton_1 = require("./TableSkeleton");
Object.defineProperty(exports, "TableSkeleton", { enumerable: true, get: function () { return TableSkeleton_1.TableSkeleton; } });
